import { rootApi } from "../../api/rootApi";

export const ordersApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    bulkInsertOrders: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/order/add`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),

    fetchAllOrderBatches: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: `/tenant/order`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),


    fetchOrderByBatchId: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/order/batch/${params.batch_id}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),

    fetchOrders: builder.mutation({
      query: (params) => {
        let url = `/tenant/orders`
        return {
          method: "POST",
          url: url,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id
          },
          body: params.body
        };
      },
    }),

    fetchOrdersByType: builder.mutation({
      query: (params) => {
        let url = `/tenant/orders/ordersByType?type=${params.type}&limit=${params.limit}&offset=${params.offset}`
        if (params.userId) {
          url += `&userId=${params.userId}`
        }
        return {
          method: "GET",
          url: url,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          }
        };
      },
    }),

    fetchOrdersById: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: `/tenant/orders/orderDetails/${params.id}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          }
        };
      },
    }),

    insertOrders: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/orders/addCsvOrders`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),

    userBySales: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/app/employee/user-by-sales`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),

    orderErrorLogs: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: `/tenant/orders/error-rows`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          }
        };
      },
    }),

    orderListCsv: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: `/tenant/orders/orderListCsv`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          }
        };
      },
    }),

    sudamaPointAllocation: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/sudama/point-allocation`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),

    sudamaPointTransfer: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/sudama/point-transfer`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),

    sudamaBonusPoints: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/sudama/bonus-points`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),

  }),
});

export const {
  useBulkInsertOrdersMutation,
  useFetchAllOrderBatchesMutation,
  useFetchOrderByBatchIdMutation,
  useFetchOrdersByTypeMutation,
  useInsertOrdersMutation,
  useFetchOrdersByIdMutation,
  useFetchOrdersMutation,
  useUserBySalesMutation,
  useOrderErrorLogsMutation,
  useOrderListCsvMutation,
  useSudamaPointAllocationMutation,
  useSudamaPointTransferMutation,
  useSudamaBonusPointsMutation,
} = ordersApi;
